<template>
    <div class="inbanner bg-cover">
        <el-image src='images/skillsbg.jpg'></el-image>
 
      <div class="inwrap l-m-c">
        <h2 class="fnt_40 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">集团介绍</h2>
        <h3 class="fnt_18 wow fadeInUp animated animated" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">Product center</h3>
      </div>
    </div>
    <div class="about" style="  padding-right:230px;padding-left:250px;">
      <div    >
        <el-row>
          <el-col :span="12" class="animate__animated animate__backInRight ">
              <video width="90%"  style="margin-top: -50px; width: 500px ; height: 500px;"  controls>
                <source src="images/c154779e3b9c6b7b612a8aa09c35c6bb.mp4" type="video/mp4">
                您的浏览器不支持 Video 标签。
              </video>
          </el-col>
          <el-col :span="12" class="animate__animated animate__backInLeft "  style=" margin-bottom: 6%;
              color: #686868;
              line-height: 2.0; font-family:  ui-sans-serif; text-align: left; /* 或者使用 left 的简写 left */ font-size:  16px !important;">
              <div style="  margin: 0 auto;" >
                  <p>2021年10月，成立技术研发中心，引进了先进的原料药和制剂研究的小试、中试生产设备和检测仪器，每年投入不低于销售额10%的科研经费，与中北大学、山西医科大学、北京结核病诊疗技术创新联盟等科研机构合作，组建了33人年轻高水平的技术研发团队，短时间内攻克了多项技术瓶颈，2021年分别被省工信厅、省科技厅认定为省级技术中心和省级技术创新中心。
                  同年12月，太药控股（山西）集团有限公司成立。</p>

                  <p>太药控股（山西）集团有限公司集中西药制备为一体的多元化高科技新型医药产业集团。注册资本为1.7亿元，资产总额20.68亿元，员工1200余人。集团旗下拥有十个子公司，其中三个为规模以上工业企业。目前集团公司实现营业收入15亿元，上缴税收逾亿元。

                          集团总部以及山西太原药业（原太原制药厂）有限公司、山西立业制药有限公司、山西达因儿童制药有限公司、山西众方医药有限公司位于太原市晋源区。</p>


                  <p>太药控股（山西）集团有限公司拥有360个“国药准字”药品批准文号，多个全国独家产品、“孤儿药”和首研产品，列入国家医保目录以及多个用药指南，是国家药品监督管理局批准的 “麻醉药品和精神类药品”定点生产单位、国家基本药物目录产品生产基地、国内半合抗生素研发及生产基地。         两个省高新技术企业；两个省级企业技术中心；一个“省级技术创新中心”；两个“专精特新中小企业”、一个“专精特新小巨人企业”；两个“科技领军储备企业”。</p>

              </div>
          </el-col>
        </el-row>
        <div class="clearfix" ></div>
      <el-row>
        <el-col :span="24" class="animate__animated animate__zoomIn"  style=" margin-bottom: 6%;
              color: #686868; padding: 30px;
              line-height: 2.0; font-family:  ui-sans-serif; text-align: left; /* 或者使用 left 的简写 left */ font-size:  16px !important;">
              <div style="  margin: 0 auto;" >
      <h2>创新</h2>
      <p>太药视创新为企业发展和改善人类健康的进阶，并为此付出持续努力。山西太原药业有限公司与全国多所知名高校建立了紧密的合作关系，共同开展新药研发、生产工艺优化等关键技术研究。通过资源共享、课程共建、技术共创和人才共育，双方在产教融合上塑造了新优势，不断提升企业的核心竞争力。太药控股（山西）集团有限公司拥有360个“国药准字”药品批准文号，多个全国独家产品、“孤儿药”和首研产品，列入国家医保目录以及多个用药指南，是国家药品监督管理局批准的 “麻醉药品和精神类药品”定点生产单位、国家基本药物目录产品生产基地、国内半合抗生素研发及生产基地。 两个省高新技术企业；两个省级企业技术中心；一个“省级技术创新中心”；两个“专精特新中小企业”、一个“专精特新小巨人企业”；两个“科技领军储备企业”。</p>
    </div>
    </el-col>
    </el-row>
      </div>
    </div>
    <div>


    </div>
    
    <div class="clearfix" ></div>
    <developmentHistory></developmentHistory>

    <div class="clearfix" ></div>
    <companyStatis></companyStatis>
</template>
<script lang="js">
import * as  http from '@/request/http'
import { useRouter} from 'vue-router';
import { useStore } from 'vuex';
import  developmentHistory from './developmentHistory.vue'
 import  companyStatis from './companyStatis.vue'


export default {
   components: {
    developmentHistory,
    companyStatis
    },
   data(){
    return {    
      article:{}
    }
   },
   methods: {
    handlePageChanged(newPage) {
       let  param = {
          pageSize: 10,
          pageNum: 1,
          isAsc: 'asc',
          articleTitle: '关于太药'
       }
        this.currentPage = newPage;
        http.articles.articlelist(param).then(res=>{
           console.log(res.data) 
           this.article=res.data.rows[0]
        })
      },
   },
   created(){
    this.handlePageChanged(1)
   },
   props: {
    user: Object
  },
  setup() {
    const router = useRouter();
    // 使用全局$store
    const store = useStore();
    function gotoDetail(item) {
      const state= item
      // router.push({ name: 'NewDetail', params: {id:2} });
      store.state.newStore.currentNew=item
      router.push({ name: 'NewDetail',state});
    }
    return {
      gotoDetail
    };
  }
}

</script>